import { NavLink } from "react-router-dom";
import { UserMenu } from "./user-menu";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/insurance", label: "Records", end: false },
  { to: "/insurance/new", label: "New Record", end: true },
  { to: "/comms", label: "Comms", end: false },
  { to: "/settings", label: "Settings", end: false },
];

export function TopBar(): React.ReactElement {
  return (
    <header className="fixed top-0 left-0 right-0 z-40 border-b bg-white">
      <div className="flex h-12 items-center justify-between px-6">
        <div className="flex items-center gap-8">
          <img src="/seagars-logo.png" alt="Seagars" className="h-8" />
          <nav className="hidden md:flex items-center gap-1" data-testid="top-nav">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`nav-${item.label.toLowerCase().replace(" ", "-")}`}
                className={({ isActive }) =>
                  `rounded-md px-3 py-1.5 text-sm transition-colors ${
                    isActive
                      ? "bg-muted font-semibold text-foreground"
                      : "text-muted-foreground hover:bg-muted/60 hover:text-foreground"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <UserMenu />
      </div>
    </header>
  );
}
